<template>
  <div class="Demo-request-successfully-received">
    <div class="container header">
      <a href="/"><img
        src="../assets/img/logo.svg"
        alt="Ludimos"
      ></a>
    </div>
    <div class="about">
      <div class="section-background">
        <div class="container">
          <div class="hero">
            <div class="text">
              <div class="row">
                <div class="col">
                  <h1>Demo request successfully received</h1>
                  <p>
                    We have received your demo request. One of our support staff
                    will reach out to you shortly to understand your
                    requirements and schedule an online demo with you.
                  </p>
                  <p>
                    If you have any further questions please contact us
                    <a href="mailto:hello@ludimos.com">hello@ludimos.com</a>
                  </p>
                  <!-- <b-button
                    type="submit"
                    class="primary-button primary with-icon"
                    @click="goHome"
                  >
                    Home
                  </b-button> -->
                </div>
                <div class="col">
                  <img
                    src="../assets/img/congratulations.gif"
                    alt=""
                  >
                </div>
              </div>
            </div>
            <div class="visual">
              <div class="background">
                <img
                  src="../assets/img/hero-background.svg"
                  alt="background visual"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
  mounted() {
    // Tracking code
    this.$ma.trackEvent({
      fb_event: "Lead",
      category: "Demo_Request",
      action: "Demo_Request",
      label: "Request Success",
      type: "Request Success",
    });
  },
  methods:{
    goHome(){
      this.$router.push('/')
    }
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`Ludimos - Demo request`, 25),
      // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
    };
  },
};
</script>
<style scoped lang="scss">
.section-background,
.hero {
  min-height: 0;
}
.header {
  padding: 20px 15px 0;
  img {
    max-width: 140px;
    opacity: 0.5;
    transition: all 0.3s ease-in-out;
    &:hover {
      opacity: 1;
    }
  }
}
</style>
